
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_fuel_level",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Fuel')
        },
        value() {
            let value = this.unitLmsgSensors.fuel_level
            if(typeof value != "string" || typeof value != "number") {
                value = value?.text
            }
            return value
        },
        icon() {
            return this.showIcon ? 'reefer__fuel' : false
        }
    },
}
</script>

<style scoped>

</style>